<template>
    <div class="t-lk-breadcrumbs">
        <router-link
            :to="item.link"
            class="t-lk-breadcrumbs__item"
            v-for="(item, index) in breadcrumbs"
            :key="'breadcrumbs' + index"
        >
            {{ item.text }}
        </router-link>
    </div>
</template>

<script>
    export default {
        name: "lk-breadcrumbs",
        props: ['breadcrumbs'],
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/components/lk/lk-breadcrumbs/lk-breadcrumbs.vue